"use client";

import { Box, Skeleton, Stack } from "@mui/material";
import Sidebar from "@/layout/sideBar";
import { Loader } from "@/components/DataBoard";

type TrendsPageSkeletonProps = {
  variant: "dashboard" | "map-board";
  showAiOverview?: boolean;
};

const FiltersSkeleton = () => (
  <Box
    sx={{
      mb: 3,
      position: "sticky",
      top: -25,
      zIndex: 100,
      pt: 2,
    }}
  >
    <Stack direction="row"  flexWrap="wrap">
      {[0, 1, 2, 3].map((idx) => (
        <Skeleton
          key={idx}
          variant="rectangular"
          height={40}
          sx={{
            minWidth: { xs: "100%", sm: "calc(50% - 8px)", md: "calc(100% / 4 - 12px)" },
            borderRadius: 0,
            marginLeft: 0
          }}
        />
      ))}
    </Stack>
  </Box>
);

const AiOverviewSkeleton = () => (
  <Box
    sx={{
      border: "0.85px solid #3636364D",
      background: "#161616",
      borderRadius: 1,
      p: 3,
      mb: 3,
    }}
  >
    <Skeleton variant="text" width={160} height={28} />
    <Skeleton variant="text" height={20} />
    <Skeleton variant="text" height={20} width="92%" />
    <Skeleton variant="text" height={20} width="84%" />
    <Skeleton variant="rectangular" height={22} width={120} sx={{ mt: 2, borderRadius: 1 }} />
  </Box>
);

export function TrendsContentSkeleton({
  variant,
  showAiOverview = true,
}: TrendsPageSkeletonProps) {
  return (
    <Box
      sx={{
        px: { xs: 2, sm: 3, md: 6 },
        py: { xs: 2, md: 3 },
      }}
    >
      <FiltersSkeleton />
      {showAiOverview ? <AiOverviewSkeleton /> : null}
      <Loader variant={variant} />
    </Box>
  );
}

export default function TrendsPageSkeleton({
  variant,
  showAiOverview = true,
}: TrendsPageSkeletonProps) {
  return (
    <Sidebar>
      <TrendsContentSkeleton
        variant={variant}
        showAiOverview={showAiOverview}
      />
    </Sidebar>
  );
}
